"use strict";
import noUiSlider from "../libs/custom/nouislider.js";
export function initInScope($scope) {
    let slider = document.querySelector('#slider-range');
    if (slider) {
        noUiSlider.create(slider, {
            start: [Number.parseInt(slider.dataset.priceMinCurrent), Number.parseInt(slider.dataset.priceMaxCurrent)],
            connect: true,
            step: 1,
            format: {
                to: (v) => Number.parseFloat(v).toFixed(0),
                from: (v) => Number.parseFloat(v).toFixed(0)
            },
            range: {
                'min': Number.parseInt(slider.dataset.priceMin),
                'max': Number.parseInt(slider.dataset.priceMax)
            }
        });

        slider.noUiSlider.on('update', function (values, handle) {
            let value = values[handle];
            if (handle) {
                document.querySelector('.js-cutout-display-max').innerHTML = value;
                document.querySelector('.js-cutout-max-hidden').setAttribute('data-value', value);
            } else {
                document.querySelector('.js-cutout-display-min').innerHTML = value;
                document.querySelector('.js-cutout-min-hidden').setAttribute('data-value', value);
            }
        });
    }

}